import { utils } from '@digital-commerce/shared-utils'
import useTranslate from '../../../../../hooks/useTranslate'

const useHsMonthlyBillTranslations = (cart) => {
  const { isBusinessCart } = utils.cart
  const translate = useTranslate()

  const getTranslationSuffix = () => {
    const path = 'priceSummary.paymentBreakdownWithMH.'

    return `${path}${isBusinessCart(cart) ? 'sbs' : 'hs'}`
  }

  return translate(getTranslationSuffix())
}

export default useHsMonthlyBillTranslations
